import { render, staticRenderFns } from "./modal-preview-reported-content.vue?vue&type=template&id=25bdfba0&scoped=true&lang=pug"
import script from "./modal-preview-reported-content.js?vue&type=script&lang=js&external"
export * from "./modal-preview-reported-content.js?vue&type=script&lang=js&external"
import style0 from "./modal-preview-reported-content.vue?vue&type=style&index=0&id=25bdfba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bdfba0",
  null
  
)

export default component.exports